"use client";

import React, { useState, useEffect } from "react";
import { Footer, Hero, Nav } from "@/components/bnp-ui";
import Script from "next/script";

interface HomeWrapperProps {
  children: any;
  minContentHeight?: string;
  footerSlot?: React.ReactNode;
  showHero?: boolean;
}

const HomeWrapper: React.FC<HomeWrapperProps> = ({
  children,
  showHero = true,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 40;
      setIsScrolled(scrolled);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="overflow-x-clip">
      <Script
        id="organization-schema"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Find Nigeria Properties",
            url: "https://www.findnigeriaproperties.com",
            logo: "https://www.findnigeriaproperties.com/logo.png",
          }),
        }}
      />

      <div
        className={`fixed w-[98vw]  lg:w-full flex justify-center z-40 transition-all duration-300 ease-linear ${
          isScrolled ? "top-0" : "top-[40px]"
        }`}
      >
        <Nav />
      </div>
      <div className="">
        {showHero && <Hero />}
        <main>
          <div>{children}</div>
        </main>
        <div className="w-full mt-auto">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HomeWrapper;
